import styled from 'styled-components';
import { StyledSection } from '../../atoms/Message/Message.styles';

import { toRem } from '../../styles';

export const StyledContactInformation = styled(StyledSection)`
  margin-top: ${toRem(35)};
`;
